<div class="row">
  <div class="col-auto mx-auto p-4 text-center">
    <h1>404 - Not found</h1>
    <h3><a mat-raised-button
        [routerLink]="'/'">Home</a></h3>
  </div>
</div>